
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, Outlet } from 'react-router-dom';

import Login from './pages/Login';
import Register from './pages/Register';
import Home from './pages/Home';
import AdminPanel from './pages/AdminPanel';
import Users from './components/Users';
import Results from './components/Results';
import CategoryForm from './components/CategoryForm';
import BuyPage from './pages/Buy';
import UserDetails from './pages/userDetail';
import ResultsHistory from './pages/ResultsHistory';
import SlotSettingsPage from './pages/SlotSettingsPage';
import AdminResetPassword from './components/AdminResetPassword';


// User layout: shared structure for all user pages
function UserLayout() {
  return (
    <div>

      <main style={{ padding: '20px' }}>
        <Outlet /> {/* Nested routes will render here */}
      </main>
    </div>
  );
}

function App() {
  const [user, setUser] = useState(null);
  const [loadingUser, setLoadingUser] = useState(true);

  useEffect(() => {
    try {
      const savedUser = localStorage.getItem('user');
      if (savedUser) setUser(JSON.parse(savedUser));
    } catch (error) {
      console.error('Error parsing user from localStorage', error);
      localStorage.removeItem('user');
    }
    setLoadingUser(false);
  }, []);

  if (loadingUser) return <div>Loading...</div>;

  return (
    <Router>
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login setUser={setUser} />} />
        <Route path="/register" element={<Register />} />
        <Route path='/profile/results' element={<ResultsHistory />} />
        {/* Protected User Routes */}
        <Route
          path="/profile/*"
          element={
            user && user.role === 'user' ? <UserLayout /> : <Navigate to="/login" />
          }
        >
          <Route index element={<Home user={user} />} /> {/* /profile */}
          <Route path="buy" element={<BuyPage />} /> {/* /profile/buy */}
          <Route path="userdetails/:id" element={<UserDetails />} />

        </Route>

        {/* Protected Admin Routes */}
        <Route
          path="/admin/*"
          element={
            user?.role === 'admin' ? (
              <AdminPanel user={user} />
            ) : (
              <Navigate to="/login" />
            )
          }
        >
          <Route index element={<AdminPanel user={user} />} /> {/* default /admin */}
          <Route path="categories" element={<CategoryForm />} />
          <Route path="results" element={<Results />} />
          <Route path="users" element={<Users />} />
          <Route path="setting" element={<SlotSettingsPage />} />
          <Route path="userdetails/:id" element={<UserDetails />} />
          <Route path="admin_password_reset" element={<AdminResetPassword />} />
        </Route>


        {/* Catch-all */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
}

export default App;
